import { useNavigate } from 'react-router-dom';
import { LogIn, UserPlus, X, Lock, ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AuthPromptModal() {
  const { authModal, closeAuthModal } = useAuth();
  const navigate = useNavigate();

  if (!authModal?.isOpen) return null;

  const handleLogin = () => {
    closeAuthModal();
    navigate('/login');
  };

  const handleRegister = () => {
    closeAuthModal();
    navigate('/register');
  };

  return (
    <div 
      className="modal-overlay fade-in" 
      onClick={closeAuthModal}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(6px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
    >
      <div 
        className="glass" 
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: '380px',
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderRadius: '24px',
          padding: '28px 24px 24px',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.6)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          position: 'relative'
        }}
      >
        <button 
          onClick={closeAuthModal}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            color: 'var(--color-text-muted)',
            cursor: 'pointer',
            padding: '4px'
          }}
        >
          <X size={20} />
        </button>

        {/* Header Icon */}
        <div 
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '20px',
            background: 'var(--gradient-primary)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '16px',
            boxShadow: '0 8px 16px rgba(108, 99, 255, 0.3)'
          }}
        >
          <Lock size={32} color="white" />
        </div>

        <h3 style={{ fontSize: '20px', fontWeight: 800, color: 'white', marginBottom: '8px' }}>
          Login or Register
        </h3>

        <p style={{ fontSize: '14px', color: 'var(--color-text-muted)', lineHeight: 1.5, marginBottom: '24px' }}>
          Please log in or register to {authModal.actionName || 'access this feature'}!
        </p>

        {/* Buttons */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <button 
            className="btn btn-primary"
            onClick={handleLogin}
            style={{ 
              width: '100%', 
              padding: '12px', 
              fontSize: '15px', 
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
          >
            <LogIn size={18} />
            Log In to Account
          </button>

          <button 
            className="btn btn-secondary"
            onClick={handleRegister}
            style={{ 
              width: '100%', 
              padding: '12px', 
              fontSize: '15px', 
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              border: '1px solid rgba(255,255,255,0.15)'
            }}
          >
            <UserPlus size={18} />
            Create New Account
          </button>

          <button 
            onClick={closeAuthModal}
            style={{ 
              background: 'transparent',
              border: 'none',
              color: 'var(--color-text-muted)',
              fontSize: '13px',
              fontWeight: 500,
              padding: '8px',
              marginTop: '4px',
              cursor: 'pointer'
            }}
          >
            Continue Browsing as Guest
          </button>
        </div>
      </div>
    </div>
  );
}
